<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M 0 2 L 0 4 L 24 4 L 24 2 Z M 0 11 L 0 13 L 24 13 L 24 11 Z M 0 20 L 0 22 L 24 22 L 24 20 Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>